export const GLOSSARY_LRTTERS_TYPE_LIST = "INFOGRAPHIC_LIST";
export const GLOSSARY_DETAILS = "GLOSSARY_DETAILS";